import { Type } from '@spotify-internal/encore-web';

import { TranslationProps } from 'etc/types';
import withTranslation from 'lib/shared/i18n/withTranslation';

interface ErrorMessageProps extends TranslationProps {
  title?: string;
  children?: React.ReactNode;
}

const ErrorMessage = ({ title, children, t }: ErrorMessageProps) => (
  <div>
    <Type.h1 paddingBottom="0.67em" variant="altoBrio">
      {title || t('subtitle_500')}
    </Type.h1>
    {children || (
      <Type.p paddingBottom="1em" variant="ballad">
        {t('message_500')}
      </Type.p>
    )}
  </div>
);

export default withTranslation('errors')(ErrorMessage);
